// // src/components/TestimonialsSection.js
// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { useInView } from 'react-intersection-observer';
// import { 
//   FaStar, 
//   FaStarHalfAlt, 
//   FaQuoteLeft, 
//   FaQuoteRight,
//   FaArrowLeft,
//   FaArrowRight,
//   FaUserTie,
//   FaUserGraduate,
//   FaUserFriends
// } from 'react-icons/fa';

// const TestimonialsSection = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   // Testimonials data
//   const testimonials = [
//     {
//       id: 1,
//       name: "Muhammad Abubakar",
//       icon: <FaUserTie />,
//       image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568311/Muhammad_Abubakar_li5fn1.jpg",
//       rating: 5,
//       text: "StayIN Centaurus exceeded all my expectations. The apartment was immaculate, with breathtaking views of Faisal Mosque. Being inside Centaurus Mall meant I could step out for meetings and shopping without any hassle. The 24/7 security and concierge service made me feel completely at home. Highly recommended for business travelers!",
//       stay: "Stayed 2 weeks • 1 Bed Apartment"
//     },
//     {
//       id: 2,
//       name: "Sardar Sdaqat",
//       icon: <FaUserGraduate />,
//       image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568311/Sardar_Sdaqat_qkgsui.jpg",
//       rating: 5,
//       text: "As a student, finding a quiet yet convenient place was crucial. The study apartment with dedicated workspace is perfect for my exam preparation. High-speed WiFi, peaceful environment, and the coffee lounge downstairs – everything I need. Plus, the Margalla Hills view during study breaks is absolutely inspiring!",
//       stay: "Stayed 6 months • 1 Bed Study Apartment"
//     },
//     {
//       id: 3,
//       name: "Hassan Khan",
//       icon: <FaUserFriends />,
//       image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568311/Hassan_Khan_kltthp.jpg",
//       rating: 5,
//       text: "We stayed for a month and it felt like a home away from home. Our daughter loved the proximity to cinema and food court. The apartment was spacious, fully equipped kitchen made meal times easy, and housekeeping kept everything spotless. The Mövenpick next door was perfect for our anniversary dinner.",
//       stay: "Stayed 1 month • 2 Bed Apartment"
//     },
//     {
//       id: 4,
//       name: "Muhammad_Ali",
//       icon: <FaUserTie />,
//       image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568906/Muhammad_Ali_1_x33ywc.jpg",
//       rating: 4.5,
//       text: "Excellent location for medical professionals working in Islamabad. Quick access to major hospitals, and the comfort after long shifts is unparalleled. The gym and snooker room helped me unwind. Staff was extremely helpful with my late-night check-ins. Will definitely return.",
//       stay: "Stayed 3 weeks • Studio Apartment"
//     }
//   ];

//   // Average rating calculation
//   const averageRating = (testimonials.reduce((acc, t) => acc + t.rating, 0) / testimonials.length).toFixed(1);
//   const totalReviews = testimonials.length;

//   // Next/Previous handlers
//   const nextTestimonial = () => {
//     setCurrentIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const prevTestimonial = () => {
//     setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 30, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.6, ease: "easeOut" }
//     },
//   };

//   // Render stars
//   const renderStars = (rating) => {
//     const stars = [];
//     const fullStars = Math.floor(rating);
//     const hasHalf = rating % 1 !== 0;

//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<FaStar key={`full-${i}`} className="text-[#c9a86c]" />);
//     }
//     if (hasHalf) {
//       stars.push(<FaStarHalfAlt key="half" className="text-[#c9a86c]" />);
//     }
//     return stars;
//   };

//   return (
//     <section className="py-12  relative overflow-hidden">

//       {/* Quote Decoration */}
//       <div className="absolute top-40 left-10 opacity-10 text-9xl text-[#c9a86c]">
//         <FaQuoteLeft />
//       </div>
//       <div className="absolute bottom-40 right-10 opacity-10 text-9xl text-[#c9a86c] rotate-180">
//         <FaQuoteRight />
//       </div>

//       <div className="container-custom relative z-10">
//         <motion.div
//           ref={ref}
//           variants={containerVariants}
//           initial="hidden"
//           animate={inView ? "visible" : "hidden"}
//           className="max-w-6xl mx-auto"
//         >
//           {/* Section Header */}
//           <motion.div variants={itemVariants} className="text-center mb-8">
//             <div className="flex items-center justify-center gap-3 mb-2">
//               <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//               <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//                 Guest Experiences
//               </span>
//               <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             </div>

//             <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight mb-4">
//               What Our{' '}
//               <span className="font-bold text-[#c9a86c]">Guests Say</span>
//             </h2>

//             {/* Rating Summary */}
//             <div className="flex items-center justify-center gap-6">
//               <div className="flex items-center gap-2">
//                 <div className="flex gap-1">
//                   {[...Array(5)].map((_, i) => (
//                     <FaStar key={i} className="text-[#c9a86c]" />
//                   ))}
//                 </div>
//                 <span className="text-2xl font-bold text-[#1a2b3c]">{averageRating}</span>
//               </div>
//               <span className="text-gray-400">|</span>
//               <span className="text-gray-500">{totalReviews}+ Verified Reviews</span>
//             </div>
//           </motion.div>

//           {/* Main Testimonial Carousel */}
//           <motion.div variants={itemVariants} className="relative">
//             {/* Current Testimonial */}
//             <div className="rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 p-8 md:p-12">
//               <div className="flex flex-col md:flex-row gap-8 md:items-start">
//                 {/* Left - Profile */}
//                 <div className="md:w-1/3">
//                   <div className="flex flex-col items-center md:items-start">
//                     {/* Profile Image */}
//                     <div className="relative mb-4">
//                       <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-[#c9a86c]/20">
//                         <img
//                           src={testimonials[currentIndex].image}
//                           alt={testimonials[currentIndex].name}
//                           className="w-full"
//                         />
//                       </div>
//                       <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-[#c9a86c] rounded-full flex items-center justify-center text-white">
//                         {testimonials[currentIndex].icon}
//                       </div>
//                     </div>

//                     {/* Name & Role */}
//                     <h3 className="text-xl font-semibold text-[#1a2b3c]">
//                       {testimonials[currentIndex].name}
//                     </h3>

//                     {/* Rating */}
//                     <div className="flex gap-1 mt-3">
//                       {renderStars(testimonials[currentIndex].rating)}
//                     </div>

//                     {/* Stay Duration */}
//                     <p className="text-xs text-gray-400 mt-4">
//                       {testimonials[currentIndex].stay}
//                     </p>
//                   </div>
//                 </div>

//                 {/* Right - Testimonial Text */}
//                 <div className="md:w-2/3">
//                   <div className="relative">
//                     <FaQuoteLeft className="text-4xl text-[#c9a86c]/20 absolute -top-4 -left-4" />
//                     <p className="text-gray-600 md:text-[17px] 2xl:text-lg leading-relaxed relative z-10">
//                       "{testimonials[currentIndex].text}"
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Navigation Buttons */}
//             <button
//               onClick={prevTestimonial}
//               className="absolute left-0 md:ml-0 ml-2 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#1a2b3c] hover:bg-[#c9a86c] hover:text-white transition-all duration-300"
//             >
//               <FaArrowLeft />
//             </button>
//             <button
//               onClick={nextTestimonial}
//               className="absolute right-0 top-1/2 md:mr-0 mr-2 -translate-y-1/2 translate-x-4 md:translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#1a2b3c] hover:bg-[#c9a86c] hover:text-white transition-all duration-300"
//             >
//               <FaArrowRight />
//             </button>
//           </motion.div>

//           {/* Dots Indicator */}
//           <div className="flex justify-center gap-2 mt-8">
//             {testimonials.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => setCurrentIndex(index)}
//                 className={`w-2 h-2 rounded-full transition-all duration-300 ${
//                   index === currentIndex 
//                     ? 'w-8 bg-[#c9a86c]' 
//                     : 'bg-gray-300 hover:bg-[#c9a86c]/50'
//                 }`}
//               />
//             ))}
//           </div>

//           {/* Bottom CTA */}
//           <motion.div 
//             variants={itemVariants}
//             className="text-center md:mt-12 mt-6"
//           >
//             <p className="text-gray-600 text-[17px] 2xl:text-lg">
//               Join our family of satisfied guests. Experience luxury at StayIN Centaurus.
//             </p>
//           </motion.div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default TestimonialsSection;


// src/components/TestimonialsSection.js
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  FaStar, 
  FaStarHalfAlt, 
  FaQuoteLeft, 
  FaQuoteRight,
  FaArrowLeft,
  FaArrowRight,
  FaUserTie,
  FaUserGraduate,
  FaUserFriends
} from 'react-icons/fa';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Testimonials data
  const testimonials = [
    {
      id: 1,
      name: "Muhammad Abubakar",
      icon: <FaUserTie />,
      image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568311/Muhammad_Abubakar_li5fn1.jpg",
      rating: 5,
      text: "StayIN Centaurus exceeded all my expectations. The apartment was immaculate, with breathtaking views of Faisal Mosque. Being inside Centaurus Mall meant I could step out for meetings and shopping without any hassle. The 24/7 security and concierge service made me feel completely at home. Highly recommended for business travelers!",
      stay: "Stayed 2 weeks • 1 Bed Apartment"
    },
    {
      id: 2,
      name: "Sardar Sdaqat",
      icon: <FaUserGraduate />,
      image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568311/Sardar_Sdaqat_qkgsui.jpg",
      rating: 5,
      text: "As a student, finding a quiet yet convenient place was crucial. The study apartment with dedicated workspace is perfect for my exam preparation. High-speed WiFi, peaceful environment, and the coffee lounge downstairs – everything I need. Plus, the Margalla Hills view during study breaks is absolutely inspiring!",
      stay: "Stayed 6 months • 1 Bed Study Apartment"
    },
    {
      id: 3,
      name: "Hassan Khan",
      icon: <FaUserFriends />,
      image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568311/Hassan_Khan_kltthp.jpg",
      rating: 5,
      text: "We stayed for a month and it felt like a home away from home. Our daughter loved the proximity to cinema and food court. The apartment was spacious, fully equipped kitchen made meal times easy, and housekeeping kept everything spotless. The Mövenpick next door was perfect for our anniversary dinner.",
      stay: "Stayed 1 month • 2 Bed Apartment"
    },
    {
      id: 4,
      name: "Muhammad_Ali",
      icon: <FaUserTie />,
      image: "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772568906/Muhammad_Ali_1_x33ywc.jpg",
      rating: 4.5,
      text: "Excellent location for medical professionals working in Islamabad. Quick access to major hospitals, and the comfort after long shifts is unparalleled. The gym and snooker room helped me unwind. Staff was extremely helpful with my late-night check-ins. Will definitely return.",
      stay: "Stayed 3 weeks • Studio Apartment"
    }
  ];

  // Average rating calculation
  const averageRating = (testimonials.reduce((acc, t) => acc + t.rating, 0) / testimonials.length).toFixed(1);
  const totalReviews = testimonials.length;

  // Next/Previous handlers
  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" }
    },
  };

  // Render stars
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="text-[#c9a86c]" />);
    }
    if (hasHalf) {
      stars.push(<FaStarHalfAlt key="half" className="text-[#c9a86c]" />);
    }
    return stars;
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Guest Reviews & Testimonials | StayIN Centaurus Islamabad</title>
        <meta name="description" content="Read real guest reviews of StayIN Centaurus serviced apartments in Islamabad. Rated 4.9/5 stars. See what our guests say about luxury apartments with Faisal Mosque views." />
        <meta name="keywords" content="StayIN reviews, Centaurus Islamabad testimonials, guest reviews Islamabad, serviced apartments feedback, StayIN Centaurus ratings" />
      </Helmet>

      {/* Schema Markup for Reviews */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "StayIN Centaurus Serviced Apartments",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": averageRating,
            "reviewCount": totalReviews,
            "bestRating": "5",
            "worstRating": "1"
          },
          "review": testimonials.map(t => ({
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": t.rating,
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": t.name
            },
            "reviewBody": t.text.substring(0, 200)
          }))
        })}
      </script>

      <section className="py-12 relative overflow-hidden" aria-label="Guest testimonials for StayIN Centaurus serviced apartments">
        {/* Quote Decoration */}
        <div className="absolute top-40 left-10 opacity-10 text-9xl text-[#c9a86c]">
          <FaQuoteLeft />
        </div>
        <div className="absolute bottom-40 right-10 opacity-10 text-9xl text-[#c9a86c] rotate-180">
          <FaQuoteRight />
        </div>

        <div className="container-custom relative z-10">
          <motion.div
            ref={ref}
            variants={containerVariants}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            className="max-w-6xl mx-auto"
          >
            {/* Section Header */}
            <motion.div variants={itemVariants} className="text-center mb-8">
              <div className="flex items-center justify-center gap-3 mb-2">
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
                <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                  Guest Experiences
                </span>
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              </div>

              <h2 className="text-4xl lg:text-5xl font-light text-[#1a2b3c] leading-tight mb-4">
                What Our{' '}
                <span className="font-bold text-[#c9a86c]">Guests Say</span>
              </h2>

              {/* Rating Summary */}
              <div className="flex items-center justify-center gap-6">
                <div className="flex items-center gap-2">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="text-[#c9a86c]" />
                    ))}
                  </div>
                  <span className="text-2xl font-bold text-[#1a2b3c]">{averageRating}</span>
                </div>
                <span className="text-gray-400">|</span>
                <span className="text-gray-500">{totalReviews}+ Verified Reviews</span>
              </div>
            </motion.div>

            {/* Main Testimonial Carousel */}
            <motion.div variants={itemVariants} className="relative">
              {/* Current Testimonial */}
              <div className="rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 p-8 md:p-12">
                <div className="flex flex-col md:flex-row gap-8 md:items-start">
                  {/* Left - Profile */}
                  <div className="md:w-1/3">
                    <div className="flex flex-col items-center md:items-start">
                      {/* Profile Image */}
                      <div className="relative mb-4">
                        <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-[#c9a86c]/20">
                          <img
                            src={testimonials[currentIndex].image}
                            alt={`${testimonials[currentIndex].name} - guest review for StayIN Centaurus Islamabad`}
                            className="w-full"
                          />
                        </div>
                        <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-[#c9a86c] rounded-full flex items-center justify-center text-white">
                          {testimonials[currentIndex].icon}
                        </div>
                      </div>

                      {/* Name & Role */}
                      <h3 className="text-xl font-semibold text-[#1a2b3c]">
                        {testimonials[currentIndex].name}
                      </h3>

                      {/* Rating */}
                      <div className="flex gap-1 mt-3">
                        {renderStars(testimonials[currentIndex].rating)}
                      </div>

                      {/* Stay Duration */}
                      <p className="text-xs text-gray-400 mt-4">
                        {testimonials[currentIndex].stay}
                      </p>
                    </div>
                  </div>

                  {/* Right - Testimonial Text */}
                  <div className="md:w-2/3">
                    <div className="relative">
                      <FaQuoteLeft className="text-4xl text-[#c9a86c]/20 absolute -top-4 -left-4" aria-hidden="true" />
                      <p className="text-gray-600 md:text-[17px] 2xl:text-lg leading-relaxed relative z-10">
                        "{testimonials[currentIndex].text}"
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation Buttons */}
              <button
                onClick={prevTestimonial}
                className="absolute left-0 md:ml-0 ml-2 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#1a2b3c] hover:bg-[#c9a86c] hover:text-white transition-all duration-300"
                aria-label="Previous testimonial"
              >
                <FaArrowLeft aria-hidden="true" />
              </button>
              <button
                onClick={nextTestimonial}
                className="absolute right-0 top-1/2 md:mr-0 mr-2 -translate-y-1/2 translate-x-4 md:translate-x-6 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-[#1a2b3c] hover:bg-[#c9a86c] hover:text-white transition-all duration-300"
                aria-label="Next testimonial"
              >
                <FaArrowRight aria-hidden="true" />
              </button>
            </motion.div>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentIndex 
                      ? 'w-8 bg-[#c9a86c]' 
                      : 'bg-gray-300 hover:bg-[#c9a86c]/50'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            {/* Bottom CTA */}
            <motion.div 
              variants={itemVariants}
              className="text-center md:mt-12 mt-6"
            >
              <p className="text-gray-600 text-[17px] 2xl:text-lg">
                Join our family of satisfied guests. Experience luxury at StayIN Centaurus.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default TestimonialsSection;